module.exports = __webpack_public_path__ + "img/JayMadeLogo.15b28d13.png";